import classNames from 'classnames';
import React, { memo } from 'react';
import styled from 'styled-components';
import { COLOR, FONT_SIZE, SIZE } from '../../styles';
import { type FieldInfoProps } from './FieldInfo.types';

const FieldInfo: React.FC<FieldInfoProps> = memo(({ colorMode = 'light', text, type }) => {
  const legendClass = classNames('field-legend', `mode-${colorMode}`, type);
  return (
    <FieldInfoWrapper className={legendClass} data-testid="field-info">
      {text}
    </FieldInfoWrapper>
  );
});

// Styled components
const FieldInfoWrapper = styled.em`
  color: ${COLOR['dark-gray-lighter']};
  display: block;
  font-family: inherit;
  font-size: ${FONT_SIZE['13']};
  font-style: normal;
  font-weight: 300;
  line-height: 18px;
  margin-top: ${SIZE['8']};
  text-rendering: optimizeLegibility;

  &.success,
  &.error,
  &.warning {
    font-weight: 500;
  }

  &.success {
    color: ${COLOR['success']};
  }

  &.error {
    color: ${COLOR['error']};
  }

  &.warning {
    color: ${COLOR['warning']};
  }

  &.mode-dark {
    &.error {
      color: ${COLOR['red-medium-light']};
    }

    &.success {
      color: ${COLOR['green']};
    }

    &.warning {
      color: ${COLOR['yellow']};
    }
  }
`;

// Display Name
FieldInfo.displayName = 'FieldInfo';

export default FieldInfo;
